import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TagCategories } from "./categories-and-tags.models";
import { AngularSvgIconModule } from "angular-svg-icon";
import { CategoryDto, TagDto } from "../../../../swagger/api.client.generated";
import { CATEGORY_COLOR_KEYS } from "../../tag-selector/tag-selector.component";

@Component({
  selector: "app-categories-and-tags",
  templateUrl: "./categories-and-tags.component.html",
  styleUrls: ["./categories-and-tags.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class CategoriesAndTagsComponent implements OnInit {
  @Input() tag: TagDto | CategoryDto;
  @Input() isSelected: boolean = false;
  @Input() isAddCustomTag: boolean = false;
  @Input() classList: string = "";
  tagCategory: string;

  get isAddCustomClass(): boolean {
    return this.classList.split(" ").includes("add-custom");
  }

  ngOnInit() {
    this.updateTagCategory();
  }

  accentVar(): string {
    const key = this.colorKey();
    return key ? `var(--color-${key})` : "var(--color-evergreen)";
  }

  gradientVar(): string {
    const key = this.colorKey();
    return key ? `var(--gradient-${key})` : "var(--color-evergreen)";
  }

  tintVar(): string {
    const key = this.colorKey();
    return key ? `var(--color-${key}-light)` : "var(--color-parchment)";
  }

  private colorKey(): string | undefined {
    if (!this.tag) return undefined;
    const id = this.isTagDto(this.tag) ? this.tag.categoryId : this.tag.id;
    return CATEGORY_COLOR_KEYS[id];
  }

  private updateTagCategory() {
    if (this.isAddCustomTag) {
      this.tagCategory = "custom";
    }
    if (!this.tag) return;

    if (this.isTagDto(this.tag)) {
      if (!this.tag.categoryId) return;
      this.tagCategory = this.formatCategoryName(
        TagCategories[this.tag.categoryId]
      );
    } else {
      if (!this.tag.id) return;
      this.tagCategory = this.formatCategoryName(TagCategories[this.tag.id]);
    }
  }

  private isTagDto(tag: TagDto | CategoryDto): tag is TagDto {
    return "categoryId" in tag;
  }

  private formatCategoryName(category: string): string {
    return (
      category?.toLowerCase().replace(/_and_/g, "-").replace(/_/g, "-") || ""
    );
  }
}
